<div>
  <!-- Footer section 2 -->
<!--  <div *ngIf="router?.url != '/home'" angly-subscribe [subscribeFormClasses]="subscribeFormClasses"></div>-->
  <div angly-footerLogoList [logoList]="footerLogo" class="client-logo"></div>
  <div class="footer-wrapper-2 py-5 bg-light">
    <div class="container container-full-width">
      <div class="row">
        <div class="col-sm-12 col-md-8 col-lg-8">
          <div class="bottom-footer mb-2">
            <h4 [innerHTML]="footerData.title"></h4>
            <h6 [innerHTML]="footerData.subTitle"></h6>
          </div>
        </div>
        <div class="col-sm-12 col-md-4 col-lg-4">
          <div class="address">
            <span class="d-block font-sm" *ngFor="let line of footerData.addressLines" [innerHTML]="line"></span>
          </div>
          <div class="social-without-bg text-lg-left mt-3">
            <ul class="list-inline mb-0">
              <li class="list-inline-item" *ngIf="footerData.facebook"><a href="{{footerData.facebook}}" target="_blank"><i class="fa fa-facebook"></i></a></li>
              <li class="list-inline-item" *ngIf="footerData.twitter"><a href="{{footerData.twitter}}" target="_blank"><i class="fa fa-twitter"></i></a></li>
              <li class="list-inline-item" *ngIf="footerData.instagram"><a href="{{footerData.instagram}}" target="_blank"><i class="fa fa-instagram"></i></a></li>
              <li class="list-inline-item" *ngIf="footerData.linkedin"><a href="{{footerData.linkedin}}" target="_blank"><i class="fa fa-linkedin"></i></a></li>
              <li class="list-inline-item" *ngIf="footerData.youtube"><a href="{{footerData.youtube}}" target="_blank"><i class="fa fa-youtube"></i></a></li>
              <li class="list-inline-item" *ngIf="footerData.vimeo"><a href="{{footerData.vimeo}}" target="_blank"><i class="fa fa-vimeo"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between mt-3">
        <a class="text-muted" [routerLink]="'/privacy-policy'">Privacy Policy</a>
        <span class="text-muted" [innerHtml]="footerData.copyright"></span>
        <a href="https://kimlundgrenassociates.com/" target="_blank" class="text-muted" [innerHtml]="footerData.poweredBy"></a>
      </div>
    </div><!-- container closed -->
  </div><!-- Footer wrapper closed -->
  <!-- Back To Top -->
  <a href="#" id="back-top" class="to-top scrolled" (click)="topScroll($event)"> <span class="to-top-icon"></span> </a>
</div>
